<template>
    <div v-if="show" class="fullscreen-preview" @click="handleBackdropClick">
        <!-- 背景遮罩 -->
        <div class="preview-backdrop" v-if="isShowSetAsBackdrop">
            <!-- @click="handleSetAsBackdrop" -->
            <div class="preview-backdrop-btn" :style="{ bottom: isEmbeddedH5 ? '4%' : '12%' }">
                <div class="flex  items-center justify-center">
                    <div class="w-20px h-20px flex mt-2px  items-center justify-center">
                        <img src="@/assets/images/home/heart.svg" class="w-full h-full"></img>
                    </div>
                    <div class="flex items-center justify-center text-16px font-800 ml-5px">
                        <span>
                            {{ numberChatMessagesTotal }}
                        </span>
                        <span class="text-12px">
                            /
                        </span>
                        <span class=" color-text-1">{{ calcValue }}</span>
                    </div>
                </div>
                <div class="text-center font-500! color-text-2">
                    After sending a message to the character, intimacy is obtained. When the intimacy reaches a
                    specified amount, the current image can be unlocked
                </div>
            </div>
        </div>

        <!-- 图片容器 -->
        <div class="image-container" @click.stop>
            <img :src="currentImage" :alt="alt" class="preview-image" @load="handleImageLoad"
                @error="handleImageError" />


            <!-- 错误状态 -->
            <div v-if="hasError" class="error-overlay">
                <van-icon name="photo-fail" size="32" color="#fff" />
                <span class="error-text">图片加载失败</span>
            </div>
        </div>

        <!-- <div class="flex items-center justify-center absolute top-20px z-999 left-20px" v-if="isShowSetAsBackdrop">
            <div class="flex  header-round rounded-10 py-4px pl-10px pr-5px items-center justify-center"
                @click="handleDownload">
                <img src="@/assets/images/home/crystal.webp" class="w-14px h-14px mr-5px mt-1px"></img>
                <div class="text-14px font-500 color-#fff">
                    {{ msgCost }}
                </div>
                <img src="@/assets/images/home/add.svg" class="w-20px h-20px ml-5px"></img>
            </div>
        </div> -->

        <div class="absolute top-50% left-50% transform -translate-x-1/2 w-30px h-30px z-99" v-if="isShowSetAsBackdrop">
            <img src="@/assets/images/other/lock.svg" class="w-full h-full"></img>
        </div>

        <!-- 顶部控制栏 -->
        <div class="top-controls">
            <div class="close-btn " @click="handleClose">
                <img src="@/assets/images/message/close_1.svg" class="w-28px h-28px" alt="">
            </div>
        </div>

        <!-- 底部控制栏 -->
        <div class="bottom-controls " :style="{ bottom: isEmbeddedH5 ? '4%' : '12%' }" v-if="isShowbackDrop">
            <!-- 下载按钮 -->
            <div class="download-btn" @click="handleDownload">
                <span>{{ t('common.download') }}</span>
            </div>
            <div class="download-btn-set" @click="emit('checkBg')">
                Set as backdrop
            </div>
        </div>
        <div class="bottom-controls" :style="{ bottom: isEmbeddedH5 ? '4%' : '12%' }" v-else>
            <!-- 下载按钮 -->
            <div class="download-btn w-100%!" @click="handleDownload">
                <span>{{ t('common.download') }}</span>
            </div>
            <div class="download-btn-chat w-100%!" @click="goToChatAnd()" v-if="isShowGotoChat">
                <span>{{ t('chat.goChat') }}</span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, computed, watch, onMounted, onUnmounted } from 'vue'
import { showLoadingToast, showSuccessToast, showErrorToast, closeToast } from '@/utils/toast'
import bridge from '@/utils/bridge'
import { useI18n } from 'vue-i18n'
import { useUserStore } from '@/stores/user'
import { MessageAPI } from '@/services/message'
import { useRandomArrayStore } from '@/stores/useRandomArrayStore'

const userStore = useUserStore()
const isEmbeddedH5 = computed(() => userStore.isEmbeddedH5)
const randomStore = useRandomArrayStore()
const msgCost = computed(() => userStore.msgCost)

interface Props {
    show: boolean
    images: string[]
    startPosition?: number
    alt?: string
    isShowSetAsBackdrop: any
    infoItem?: any
    isShowbackDrop?: boolean
    isShowGotoChat?: boolean
    numberChatMessages?: number
    numberChatMessagesTotal?: number
}

interface Emits {
    (e: 'update:show', value: boolean): void
    (e: 'close'): void
    (e: 'checkBg'): void
    (e: 'unlockSuccess', imageId: number): void
    (e: 'goToChat'): void
}

const props = withDefaults(defineProps<Props>(), {
    startPosition: 0,
    alt: '图片预览',
    isShowSetAsBackdrop: false,
    isShowbackDrop: true,
    isShowGotoChat: false,
    numberChatMessages: 0,
    numberChatMessagesTotal: 0
})

const emit = defineEmits<Emits>()

// 响应式数据
const currentIndex = ref(props.startPosition)
const loading = ref(false)
const hasError = ref(false)
const { t } = useI18n()

// 计算属性
const currentImage = computed(() => {
    return props.images[currentIndex.value] || ''
})

const calcValue = computed(() => {
    const n = (props.numberChatMessages || 0) + 1
    if (n < 5) return n
    return n * (n - 4)
})

const goToChatAnd = () => {

    emit('goToChat')
}

// 监听图片变化
watch(() => props.images, () => {
    if (props.images.length > 0) {
        currentIndex.value = Math.min(props.startPosition, props.images.length - 1)
    }
}, { immediate: true })

// 监听显示状态
watch(() => props.show, (newVal) => {
    if (newVal) {
        // 显示时重置状态
        loading.value = true
        hasError.value = false
        // 阻止背景滚动
        document.body.style.overflow = 'hidden'
    } else {
        // 隐藏时恢复背景滚动
        document.body.style.overflow = ''
    }
})

// 事件处理
const handleClose = () => {
    emit('update:show', false)
    emit('close')
}

const handleBackdropClick = (e: Event) => {
    if (e.target === e.currentTarget) {
        handleClose()
    }
}

// 不做本地缓存，直接使用来自父组件的锁定状态（避免一次解锁后影响其他图片）

const handleSetAsBackdrop = async () => {
    try {
        showLoadingToast(t('unlocking'))
        const res = await MessageAPI.unlockAlbum({
            imageId: props.infoItem.id,
        })

        if (res.code === 200) {
            // 解锁成功
            closeToast()
            showSuccessToast(t('unlockSuccess'))

            // 通知父组件解锁成功
            emit('unlockSuccess', props.infoItem.id)
        } else {
            closeToast()
            showErrorToast(res.msg || t('unlockFailed'))
        }
    } catch (error) {
        closeToast()
        console.error('解锁失败:', error)
        showErrorToast(t('unlockFailed'))
    }
}

const handleImageLoad = () => {
    loading.value = false
    hasError.value = false
}

const handleImageError = () => {
    loading.value = false
    hasError.value = true
}

const handlePrev = () => {
    if (currentIndex.value > 0) {
        currentIndex.value--
        loading.value = true
        hasError.value = false
    }
}

const handleNext = () => {
    if (currentIndex.value < props.images.length - 1) {
        currentIndex.value++
        loading.value = true
        hasError.value = false
    }
}


// 下载功能
const handleDownload = async () => {
    showLoadingToast(t('downloading...'))
    await bridge.call(randomStore.randomArray[3], {
        image: currentImage.value
    })
}

// 键盘事件处理
const handleKeydown = (e: KeyboardEvent) => {
    if (!props.show) return

    switch (e.key) {
        case 'Escape':
            handleClose()
            break
        case 'ArrowLeft':
            handlePrev()
            break
        case 'ArrowRight':
            handleNext()
            break
    }
}

// import { ref, onMounted, onUnmounted } from "vue";

const innerHeight = ref(window.innerHeight);
const resize = () => {
    innerHeight.value = window.innerHeight;
};

// bridge.on('onPhotoSaveSuccess', (data) => {
//     console.log('📸 Flutter 返回数据:', data)
//     showSuccessToast(t('downloadSuccess'), data)
// })

// 生命周期
onMounted(() => {

    window.addEventListener("resize", resize);
    document.addEventListener('keydown', handleKeydown)
})

onUnmounted(() => {
    window.removeEventListener("resize", resize);

    document.removeEventListener('keydown', handleKeydown)
    document.body.style.overflow = ''
})
</script>

<style scoped lang="scss">
.fullscreen-preview {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
}

.preview-backdrop {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
    // background: rgba(0, 0, 0, 0.9);
    background: rgba(1, 3, 27, 0.5);

    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);

    display: flex;
    align-items: center;
    justify-content: center;

    .preview-backdrop-btn {
        position: absolute;
        bottom: 2%;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 10px;
        padding: 10px;
        width: 90%;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 23px;
        font-weight: 900;
        font-size: 16px;
        color: #FFFFFF;
        font-size: 12px;
    }
}

.image-container {
    position: relative;
    max-width: 100vw;
    height: 100vh;
    min-height: 100dvh;
    display: flex;
    align-items: center;
    justify-content: center;
}

.preview-image {
    max-width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;

    //   border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
}

.loading-overlay,
.error-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    color: #fff;
}

.loading-text,
.error-text {
    font-size: 14px;
    font-weight: 500;
}

.top-controls {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 999;
}

.close-btn {
    // background: rgba(0, 0, 0, 0.6);
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background: rgba(0, 0, 0, 0.8);
    }
}

.bottom-controls {
    position: absolute;
    bottom: 12%;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    z-index: 10;
    width: 90%;
}

.image-index {
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    background: rgba(0, 0, 0, 0.6);
    padding: 8px 16px;
    border-radius: 20px;
}

.download-btn {
    width: 40%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    //   background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    background: linear-gradient(180deg, #5A68FF 0%, #95A5FF 100%);
    color: #fff;
    padding: 12px 24px;
    border-radius: 25px;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
    transition: transform 0.2s, box-shadow 0.2s;
    font-weight: 900;
    font-size: 16px;
    color: #FFFFFF;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
    }

    &:active {
        transform: translateY(0);
    }
}

.download-btn-chat {
    width: 40%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    //   background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    background: linear-gradient(180deg, #5A68FF 0%, #95A5FF 100%);
    color: #fff;
    padding: 12px 24px;
    border-radius: 25px;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
    transition: transform 0.2s, box-shadow 0.2s;
    font-weight: 900;
    font-size: 16px;
    color: #FFFFFF;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
    }

    &:active {
        transform: translateY(0);
    }

    background: linear-gradient(180deg, #9B75F3 0%, #6026CF 100%);
}

.download-btn-set {
    width: 60%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg, #9B75F3 0%, #6026CF 100%);
    font-weight: 600;
    font-size: 14px;
    transition: transform 0.2s, box-shadow 0.2s;
    font-weight: 900;
    font-size: 16px;
    color: #FFFFFF;
    padding: 12px 24px;
    border-radius: 25px;
}

.nav-buttons {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    pointer-events: none;
}

.nav-btn {
    width: 50px;
    height: 50px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    pointer-events: auto;

    &:hover:not(.disabled) {
        background: rgba(0, 0, 0, 0.8);
        transform: scale(1.1);
    }

    &.disabled {
        opacity: 0.3;
        cursor: not-allowed;
    }
}

.prev-btn {
    left: 20px;
}

.next-btn {
    right: 20px;
}

.header-round {
    background: rgba(255, 255, 255, 0.1);
}
</style>
